export enum PMCalendarSelectionModeEnum {
  SINGLE = "single",
  MULTIPLE = "multiple",
  RANGE = "range",
}

export type PMCalendarSelectionMode = `${PMCalendarSelectionModeEnum}`;
